module.exports = __webpack_public_path__ + "b3745bd257cf7643fea4dafb43b8ee6a.pdf";